import { createContext } from '@chakra-ui/react-utils';
import type { SystemStyleObject } from '@chakra-ui/system';

import type { MessageGroupPart } from './types';

export type MessageGroupStyles = Partial<
  Record<MessageGroupPart, SystemStyleObject>
>;

const [MessageGroupStylesProvider, useMessageGroupStyles] =
  createContext<MessageGroupStyles>({
    name: 'MessageGroupStylesContext',
    strict: true,
    errorMessage:
      'useMessageGroupStyles: `context` is undefined. Seems you forgot to wrap all message group components within `<MessageGroup />`',
  });

export { MessageGroupStylesProvider, useMessageGroupStyles };
